export default "__VITE_ASSET__BuDuOYbw__"